import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, useContext, useMemo } from 'react';
import { AnyRenderedResult } from './result.types';
import { getResultMethods } from './getResultMethods';
import { AnyRenderedQuestion, GivenAnswers } from '../_questions/question.types';
import { getRelevantQuestions } from '../_data/filterQuestions';
const ResultListContext = createContext<{
  relevantQuestions: Array<AnyRenderedQuestion>;
  givenAnswers: GivenAnswers;
} | undefined>(undefined);
export const ResultList = t0 => {
  const $ = _c(11);
  const {
    children,
    allQuestions,
    givenAnswers
  } = t0;
  let t1;
  if ($[0] !== allQuestions || $[1] !== givenAnswers) {
    t1 = getRelevantQuestions(allQuestions, givenAnswers);
    $[0] = allQuestions;
    $[1] = givenAnswers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== givenAnswers || $[4] !== t1) {
    t2 = {
      relevantQuestions: t1,
      givenAnswers
    };
    $[3] = givenAnswers;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const context = t2;
  let t3;
  if ($[6] !== children) {
    t3 = <div>{children}</div>;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== context || $[9] !== t3) {
    t4 = <ResultListContext.Provider value={context}>{t3}</ResultListContext.Provider>;
    $[8] = context;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const useResultListContext = () => {
  const context = useContext(ResultListContext);
  if (context == null) {
    throw new Error("useResultListContext must be used within a ResultListProvider");
  }
  return context;
};
export const ResultListItem = t0 => {
  const $ = _c(6);
  const {
    result,
    headingLevel
  } = t0;
  let t1;
  if ($[0] !== result.type) {
    t1 = getResultMethods(result.type);
    $[0] = result.type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    Render
  } = t1;
  let t2;
  if ($[2] !== Render || $[3] !== headingLevel || $[4] !== result) {
    t2 = <Render result={result} key={result.id} headingLevel={headingLevel} />;
    $[2] = Render;
    $[3] = headingLevel;
    $[4] = result;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};